module.exports = __webpack_public_path__ + "img/docking-1.36d68eeb.png";